import Plyr from "plyr";
let Rellax = require("rellax");
import tippy from "tippy.js";
let currentPlyrInstance;
let players3 = [];
import UAParser from "ua-parser-js";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".rellax")) {
    var rellax = new Rellax(".rellax");
  }

  // cast
  //global variables
  var rjs_cursor = document.getElementById("rjs_cursor"); //Getting the cursor
  var bodyy = document.querySelectorAll(".cast-inner"); //Get the body element
  var trigger = document.querySelector(".bio-trigger");

  if (rjs_cursor !== null) {
    var rect = trigger.getBoundingClientRect();
    var centerX = rect.left;
    var centerY = rect.top;

    // get the center coordinates of the first trigger and lock rjs_cursor to it
    // these needs to be set on page load, not readr
    rjs_cursor.style.transform = `translate(${centerX}px, ${centerY}px)`;
    // make it the size of .bio-trigger
    rjs_cursor.style.width = rect.width + "px";
    rjs_cursor.style.height = rect.height + "px";

    //Functions for showing the cursor
    function rjs_show_cursor(e) {
      if (rjs_cursor.classList.contains("rjs_cursor_hidden")) {
        rjs_cursor.classList.remove("rjs_cursor_hidden");
      }
      rjs_cursor.classList.add("rjs_cursor_visible");
    }
    //Functions for hiding the cursor
    function rjs_hide_cursor(e) {
      if (rjs_cursor.classList.contains("rjs_cursor_visible")) {
        rjs_cursor.classList.remove("rjs_cursor_visible");
      }
      rjs_cursor.classList.add("rjs_cursor_hidden");
    }

    //Functions for when the mouse moves
    function rjs_mousemove(e) {
      rjs_cursor.style.borderColor = "white";

      rjs_cursor.classList.add("rjs_cursor_transition");
      rjs_show_cursor(); //Toggle show/hide

      var rjs_cursor_width = rjs_cursor.offsetWidth * 0.5;
      var rjs_cursor_height = rjs_cursor.offsetHeight * 0.5;

      // Calculate the distance between the cursor and each .bio-trigger element
      var triggers = document.querySelectorAll(".bio-trigger");
      var closestTrigger = null;
      var closestDistance = Infinity;

      triggers.forEach(function (trigger) {
        // if trigger is being hovered over, give it a closest class
        if (trigger.contains(e.target)) {
          trigger.classList.add("closest");
          closestTrigger = trigger;
        } else {
          trigger.classList.remove("closest");
        }
      });

      // If there is a closest .bio-trigger element, update the cursor position to be at its center
      if (closestTrigger) {
        var rect = closestTrigger.getBoundingClientRect();
        var x = rect.left + rect.width / 2;
        var y = rect.top + rect.height / 2;
        var rjs_cursor_x = x - rjs_cursor_width;
        var rjs_cursor_y = y - rjs_cursor_height;
        var rjs_cursor_pos = `translate(${rjs_cursor_x}px, ${rjs_cursor_y}px)`;
        rjs_cursor.style.transform = rjs_cursor_pos;
        rjs_cursor.style.transition = "transform 0.3s ease-in-out";
      }
    }

    //Eventlisteners

    // bodyy.addEventListener('mousemove', rjs_mousemove);
    bodyy.forEach(function (element) {
      element.addEventListener("mousemove", rjs_mousemove);
    });

    bodyy.forEach(function (element) {
      element.addEventListener("mouseleave", rjs_hide_cursor);
    });

    window.addEventListener("resize", function () {
      var rjs_cursor = document.getElementById("rjs_cursor"); //Getting the cursor
      var body = document.querySelector(".headshots"); //Get the body element
      var trigger = document.querySelector(".bio-trigger");
      var rect = trigger.getBoundingClientRect();
      rjs_cursor.style.width = rect.width + "px";
      rjs_cursor.style.height = rect.height + "px";
    });

    function updateYPosition() {
      var rjs_cursor = document.getElementById("rjs_cursor"); //Getting the cursor

      // add another class onto .closest called locked
      var closestTrigger = document.querySelector(".closest");
      closestTrigger.classList.add("locked");
      //give rjs_cursor a transpatent border color
      rjs_cursor.style.borderColor = "transparent";
    }

    // add event listener for scroll
    document.addEventListener("scroll", updateYPosition);

    // On body mousemove
    document.addEventListener("mousemove", function clearClass() {
      var triggers = document.querySelectorAll(".bio-trigger");
      triggers.forEach(function (trigger) {
        trigger.classList.remove("locked");
      });
    });

    //Hover behaviour
    // I think I can remover this
    function rjs_hover_cursor(e) {
      rjs_cursor.classList.add("rjs_cursor_hover");
    }

    function rjs_unhover_cursor(e) {
      rjs_cursor.classList.remove("rjs_cursor_hover");
    }

    document.querySelectorAll(".bio-trigger").forEach((item) => {
      //A custom class
      item.addEventListener("mouseover", rjs_hover_cursor);
      item.addEventListener("mouseleave", rjs_unhover_cursor);
    });

    var bioTriggers = document.querySelectorAll(".bio-trigger");
    bioTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var postIndex = this.getAttribute("data-post-index");
        var bioContent = document.querySelector("#bio-" + postIndex).innerHTML;

        document.querySelector(".bio").innerHTML = bioContent;
        var selectedTriggers = document.querySelectorAll(
          ".bio-trigger.selected"
        );
        selectedTriggers.forEach(function (selectedTrigger) {
          selectedTrigger.classList.remove("selected");
        });
        this.classList.add("selected");
      });
    });

    // set rjs cursor to class .selected
    var headshots = document.querySelectorAll(".cast-inner");
    // if mouse leaves the selected div class
    headshots.forEach(function (element) {
      element.addEventListener("mouseleave", function () {
        var trigger = document.querySelector(".bio-trigger.selected");
        var rect = trigger.getBoundingClientRect();
        var centerX = rect.left;
        var centerY = rect.top;

        rjs_cursor.style.transform = `translate(${centerX}px, ${centerY}px)`;
      });
    });
  }

  // const player = new Plyr('.wp-block-embed__wrapper');
  initPlyr();
  initPlyr3();

  //accordion

  function collapseSection(element) {
    var sectionHeight = element.scrollHeight;
    var elementTransition = element.style.transition;
    element.style.transition = "";
    requestAnimationFrame(function () {
      element.style.height = sectionHeight + "px";
      element.style.transition = elementTransition;
      requestAnimationFrame(function () {
        element.style.height = 0 + "px";
      });
    });
    element.setAttribute("data-collapsed", "true");
  }

  function onTransitionEnd(e) {
    e.target.removeEventListener("transitionend", onTransitionEnd);
    e.target.style.height = null;
  }

  function expandSection(element) {
    var sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + "px";
    element.addEventListener("transitionend", onTransitionEnd);
    element.setAttribute("data-collapsed", "false");
  }

  // doesnt work on desktop :) as .casts-inner-bio.accordion is not loaded into .bio. only everything inside if it
  document.querySelectorAll(".item-heading").forEach(function (itemHeading) {
    itemHeading.addEventListener("click", function (e) {
      var item = e.target.closest(".accordion");
      var content = item.querySelector(".item-content");
      var button = item.querySelector(".arrow");
      var isCollapsed = content.getAttribute("data-collapsed") === "true";

      if (isCollapsed) {
        expandSection(content);
        content.setAttribute("data-collapsed", "false");
        button.classList.add("active");
      } else {
        collapseSection(content);
        button.classList.remove("active");
      }
    });
  });

  // hamburger
  var hamburger = document.querySelector(".hamburger");
  var hamburgerClose = document.querySelector(".hamburger-close");
  var body = document.querySelector("body");

  if (hamburger) {
    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      body.classList.toggle("menu-is-open");
    });
  }

  if (hamburgerClose) {
    hamburgerClose.addEventListener("click", function () {
      hamburger.classList.remove("is-active");
      body.classList.remove("menu-is-open");
    });
  }

  // sub-menu items
  var hasChildren = document.querySelectorAll(
    "#mobile-menu>nav>ul>li.menu-item-has-children>a"
  );
  //on click of mobile menu item with children
  hasChildren.forEach(function (item) {
    item.addEventListener("click", function (e) {
      // prevent default only of the a item clicked
      e.preventDefault();
      //toggle the class of the parent li
      item.parentNode.classList.toggle("open");
    });
  });

  // video page

  const videoTriggers = document.querySelectorAll(".video-trigger");
  const showHide = document.querySelectorAll('[class^="video-showhide"]');

  videoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const postIndex = this.dataset.postIndex;
      const videoContent = document.querySelector(
        `.video-showhide-${postIndex}`
      );

      // Hide all videos
      showHide.forEach((video) => {
        video.classList.remove("show");
      });

      // Show the selected video
      videoContent.classList.add("show");

      // document.querySelector('.video-details').innerHTML = videoContent;
      videoTriggers.forEach((trigger) => {
        trigger.parentNode.classList.remove("active");
      });
      this.parentNode.classList.add("active");
    });
  });

  // type Instance[]
  // const instances1 = tippy('#tooltip-360', {
  //     content: document.querySelector('#tooltip-360').getAttribute('data-360-content'),
  //     allowHTML: true
  // });

  // // type Instance[]
  // const instances2 = tippy('#tooltip-cinematic', {
  //     content: document.querySelector('#tooltip-cinematic').getAttribute('data-cinematic-content'),
  //     allowHTML: true
  // });

  document.querySelectorAll("[data-tippy-content]").forEach(function (elem) {
    tippy(elem, {
      content: elem.getAttribute("data-tippy-content"),
      allowHTML: true,
      offset: [0, 20],
    });
  });

  // show/hide password

  if (jQuery(".ihc-login-form-wrap .ihc-hide-pw").length > 0) {
    jQuery(".ihc-login-form-wrap .ihc-hide-pw").each(function (index, button) {
      jQuery(button).on("click", function () {
        var pass = jQuery(button).prev();
        if ("password" === pass.attr("type")) {
          pass.attr("type", "text");
          jQuery(this)
            .children()
            .removeClass("dashicons-visibility")
            .addClass("dashicons-hidden");
        } else {
          pass.attr("type", "password");
          jQuery(this)
            .children()
            .removeClass("dashicons-hidden")
            .addClass("dashicons-visibility");
        }
      });
    });
  }

  const parser = new UAParser();
  const result = parser.getResult();

  // Check if the device is an iPhone or iPad
  const isAppleDevice =
    result.device &&
    (result.device.model === "iPhone" || result.device.model === "iPad");

  // Check if the browser is Firefox. Firefox shows as Safari on browser detect so this is the only way to check
  const isFirefox = result.browser && result.browser.name === "Safari";

  if (isAppleDevice && isFirefox) {
    document.querySelector(".firefox-notice").classList.add("show");
  }

  // close alter
  // on .alert-close click hide parent
  document.querySelectorAll(".alert-close").forEach(function (alertClose) {
    alertClose.addEventListener("click", function (e) {
      e.preventDefault();
      this.parentNode.classList.remove("show");
    });
  });

  const iPadMessage = document.querySelector(".ipad-message");

  if (isTouchDevice() && iPadMessage) {
    iPadMessage.classList.add("show");
  }

  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }
});

function initPlyr() {
  const players = Array.from(
    document.querySelectorAll(".wp-block-embed__wrapper")
  ).map((p) => new Plyr(p));
}

function initPlyr3() {
  const players3 = Array.from(
    document.querySelectorAll(".video-details-video")
  ).map((p) => new Plyr(p));

  const videoTriggers = document.querySelectorAll(".video-trigger");
  videoTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      players3.forEach(function (p) {
        p.pause();
      });
    });
  });

  players3.forEach(function (player) {
    player.on("play", function (event) {
      // Pause all other players
      players3.forEach(function (p) {
        if (p !== player) {
          p.pause();
        }
      });
    });
  });
}

window.addEventListener("load", headerScroll);
window.addEventListener("resize", headerScroll);
window.addEventListener("scroll", headerScroll);

function headerScroll() {
  var scroll = window.pageYOffset || document.documentElement.scrollTop;
  var body = document.querySelector("body");

  if (scroll >= 30) {
    body.classList.add("is-scrolled");
  } else {
    body.classList.remove("is-scrolled");
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const userLoginInput = document.querySelector('input[name="user_login"]');

  if (userLoginInput) {
    userLoginInput.addEventListener('input', () => {
      userLoginInput.value = userLoginInput.value.toLowerCase().replace(/\s+/g, '');
    });
  }
});
